import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import api, { formatApiError } from "../api";
import { useT } from "../i18n";
import Header from "../components/Header";
import PasswordInput from "../components/PasswordInput";

export default function ResetPage() {
  const { t } = useT();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen">
      <Header />
      <main className="max-w-md mx-auto px-4 py-12">
        <h1 className="text-3xl font-extrabold tracking-tight text-[#1F2937]" style={{ fontFamily: "Manrope" }}>
          {t("reset.title")}
        </h1>
        {done ? (
          <div className="mt-6">
            <p data-testid="reset-success-msg" className="text-sm font-semibold text-[#065F46] bg-[#D1FAE5] border border-[#34D399]/50 rounded-xl px-4 py-3">
              {t("reset.success")}
            </p>
            <Link to="/espace-pro" data-testid="reset-login-link"
              className="inline-block mt-4 bg-[#0D4045] text-[#FDFBF7] text-sm font-semibold px-6 py-3 rounded-full hover:bg-[#0a3237] transition-colors duration-200">
              {t("login.tab.login")}
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="flex flex-col gap-4 mt-6" data-testid="reset-form">
            <PasswordInput value={password} minLength={8}
              onChange={(e) => setPassword(e.target.value)}
              testid="reset-password-input" toggleTestid="reset-toggle-password" />
            <button type="submit" disabled={loading || !token} data-testid="reset-submit-btn"
              className="flex items-center justify-center gap-2 min-h-[48px] bg-[#0D4045] text-[#FDFBF7] font-semibold rounded-full hover:bg-[#0a3237] transition-colors duration-200 disabled:opacity-60">
              <KeyRound size={16} /> {loading ? "…" : t("reset.submit")}
            </button>
          </form>
        )}
      </main>
    </div>
  );
}
